var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boxActions-MenuProgram",
    transform: "translate(-21.000000, -292.000000)",
    stroke: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(0.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-460",
    points: "13.3928571 2.67857143 13.3928571 16.0714286 1.60714286 16.0714286 1.60714286 2.67857143"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 6.42857143,
    x2: 7.5,
    y2: 12.3214286,
    id: "Stroke-461"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.82142857,
    y1: 6.42857143,
    x2: 4.82142857,
    y2: 12.3214286,
    id: "Stroke-462"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1785714,
    y1: 6.42857143,
    x2: 10.1785714,
    y2: 12.3214286,
    id: "Stroke-463"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-464",
    points: "4.82142857 2.67857143 4.82142857 -3.89910326e-13 10.1785714 -3.89910326e-13 10.1785714 2.67857143"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 2.67857143,
    x2: 0,
    y2: 2.67857143,
    id: "Stroke-465"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.ce7450d861f5d559d3f322ab15aa9ff5.svg";
export { ForwardRef as ReactComponent };